module.exports = __webpack_public_path__ + "img/icon-services.f2d9652d.svg";